// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_fr-3";
export var flatBottomCorners = "_fr-5";
export var productImage = "_fr-0";
export var quantityContainer = "_fr-2";
export var quantityHeader = "_fr-6";
export var tooltip = "_fr-1";
export var wrapAndEllipsesOverflow = "_fr-4";